/* eslint-disable indent */
/* eslint-disable indent */
<template>
    <tr>
        <td v-for="key in columns" :key='key' style="min-width:120px">
            <div v-if="typeof item[key] === 'boolean'">
                <input type="checkbox" v-model="item[key]"
                       :disabled="readonly ? true : false"
                       :title="$t(captions[key])"
                       @change="checkboxChange" />
            </div>
            <div v-else-if="item[key] instanceof Date || isDate(key)">
                <date-picker v-model="item[key]"
                             :readonly="readonly"
                             :format="dateFormat">
                </date-picker>
            </div>
            <div v-else>
                <span v-if="isEditable(key)">
                    <input class="form-control" :type="getInputType(key)"
                           :min="getInputMin(key)"
                           :max="getInputMax(key)"
                           :step="getInputStep(key)"
                           :size="getInputSize(key)"
                           :name="key"
                           v-if="isEditable(key)"
                           :disabled="readonly ? true : false"
                           v-model="item[key]"
                           @input="emitEvent($event, item)"
                           @change="emitEvent($event, item)" />
                </span>
                <span v-else>
                    <span v-if="item[key] && htmlColumns && htmlColumns.indexOf(key) > -1" v-html="htmlSpan(item[key])"/>
                    <span v-else>{{ item[key] }}</span>

                </span>
            </div>
        </td>
        <td v-if="btns">
            <btns-template :args="{ ...this.item, btns: this.btns }">
            </btns-template>
        </td>
    </tr>

</template>

<script>
    import bus from '../sidemenu/event-bus'
    import BtnsTemplate from '@/components/grid/CustomGridBtnsTemplate'
    import DatePicker from '@/components/datepicker/DatePicker'

    export default {
        name: 'custom-grid-item',
        components: {
            'btns-template': BtnsTemplate,
            'date-picker': DatePicker
        },
        props: {
            item: Object,
            columns: Array,
            htmlColumns: Array,
            btns: Array,
            gridName: {
                type: String
            },
            editableColumns: Array,
            dateFormat: {
                type: String,
                default() {
                    return '';
                }
            },
            dateColumns: Array,
            readonly: {
                type: Boolean,
                default: false
            },
            options: {}, // { columnName: { inputType: '', } }
            captions: Object
        },
        data () {
            return {
                templateArgs: { ...this.item, btns: this.btns }
            }
        },
        created () {
            this.bus = bus
        },
        mounted () {
        },
        methods: {
            checkboxChange () {
                this.bus.$emit('checkbox-changed', this.item, this.gridName)
            },
            isEditable (key) {
                return Array.isArray(this.editableColumns)
                    && this.editableColumns.length > 0
                    && this.editableColumns.indexOf(key) > -1
            },
            isDate (val) {
                if (!this.dateColumns) {
                    return false
                }
                return this.dateColumns.includes(val)
            },
            getInputType (key) {
                if (this.options && this.options.hasOwnProperty(key) && this.options[key].hasOwnProperty("inputType")
                    && this.options[key].inputType) {
                    return this.options[key].inputType
                }

                if (typeof this.item[key] === 'number') {
                    return 'number'
                }

                return 'text'
            },
            getInputMin (key) {
                if (this.options && this.options.hasOwnProperty(key) && this.options[key].hasOwnProperty("min")) {
                    const min = Number(this.options[key].min)
                    if (!isNaN(min)) {
                        return min
                    } else {
                        return ''
                    }
                }

                return ''
            },
            getInputMax (key) {
                if (this.options && this.options.hasOwnProperty(key) && this.options[key].hasOwnProperty("max")) {
                    const max = Number(this.options[key].max)
                    if (!isNaN(max)) {
                        return max
                    } else {
                        return ''
                    }
                }

                return ''
            },
            getInputStep (key) {
                if (this.options && this.options.hasOwnProperty(key) && this.options[key].hasOwnProperty("step")) {
                    const step = Number(this.options[key].step)
                    if (!isNaN(step)) {
                        return step
                    } else {
                        return ''
                    }
                }

                return ''
            },
            getInputSize (key) {
                if (this.options && this.options.hasOwnProperty(key) && this.options[key].hasOwnProperty("size")) {
                    const size = Number(this.options[key].size)
                    if (!isNaN(size)) {
                        return size
                    } else {
                        return 70
                    }
                }

                return 70
            },
            emitEvent (event, item) {
                this.bus.$emit('custom-grid-item-input-event', {
                    type: event.type,
                    name: event.target.name,
                    isCheckbox: event.target.type === 'checkbox',
                    value: event.target.value,
                    valueAsDate: event.target.valueAsDate,
                    valueAsNumber: event.target.valueAsNumber,
                    checked: event.target.checked
                }, item, this.gridName)
            },
            htmlSpan(text) {
                return `<span>${text}</span>`
            }
        }
    }
</script>

<style>
</style>
